module.exports = __webpack_public_path__ + "img/74ne.b66af977.svg";